import { render, staticRenderFns } from "./DastPromoBlock.vue?vue&type=template&id=7cf18618&scoped=true"
import script from "./DastPromoBlock.vue?vue&type=script&lang=js"
export * from "./DastPromoBlock.vue?vue&type=script&lang=js"
import style0 from "./DastPromoBlock.vue?vue&type=style&index=0&id=7cf18618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf18618",
  null
  
)

export default component.exports